var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "schedule-detaisl-wrapper" },
    [
      _vm.schedule.imageUrl
        ? _c("img", {
            staticClass: "poster-image",
            attrs: { src: _vm.schedule.imageUrl },
          })
        : _vm._e(),
      _c("ScheduleRow", {
        attrs: { schedule: _vm.schedule, "show-link-icon": false },
      }),
      _vm.schedule.externalLink
        ? _c(
            "button",
            {
              staticClass: "go-to-arena",
              on: {
                click: function ($event) {
                  return _vm.goToLink(_vm.schedule.externalLink)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("To read more")) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }